import React, { ReactChild } from "react";
import { Modal } from "antd";
import { ModalProps } from "antd/es/modal";

interface Props extends ModalProps {
    children: ReactChild;
    content?: string;
    title?: string;
    onSuccess: () => void;
}
const Index = ({
    title = "确定删除吗?",
    children,
    content,
    onSuccess,
    ...restProps
}: Props) => {
    function clickEvents() {
        Modal.confirm({
            ...restProps,
            title,
            content,
            onOk: async () => {
                await onSuccess();
            }
        });
    }
    return <span onClick={clickEvents}>{children}</span>;
};

export default Index;
